import script from "./EntityValueRow.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityValueRow.vue?vue&type=script&setup=true&lang=js"

import "./EntityValueRow.vue?vue&type=style&index=0&id=5ceeaf3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ceeaf3e"]])

export default __exports__